const TOKEN_KEY = 'HEER_ACCESS_TOKEN'
const APP_TOKEN_KEY = 'APP_ACCESS_TOKEN'

const getAccessToken = () => {
  return localStorage.getItem(TOKEN_KEY)
}

const setAccessToken = (token) => {
  localStorage.setItem(TOKEN_KEY, token)
}

const removeAccessToken = () => {
  localStorage.removeItem(TOKEN_KEY)
}

const hasAccessToken = () => {
  const token = getAccessToken()
  return (token?.length ?? 0) > 0
}

const getAppAccessToken = (appId) => {
  if (!appId) {
    return null
  }
  return localStorage.getItem(APP_TOKEN_KEY + appId)
}

const setAppAccessToken = (appId, token) => {
  if (!appId) {
    return
  }
  localStorage.setItem(APP_TOKEN_KEY + appId, token)
}

const removeAppAccessToken = (appId) => {
  if (!appId) {
    return
  }
  localStorage.removeItem(APP_TOKEN_KEY + appId)
}

const hasAppAccessToken = (appId) => {
  if (!appId) {
    return false
  }
  const token = getAppAccessToken(appId)
  return (token?.length ?? 0) > 0
}

export {
  getAccessToken,
  setAccessToken,
  removeAccessToken,
  hasAccessToken,
  getAppAccessToken,
  setAppAccessToken,
  removeAppAccessToken,
  hasAppAccessToken
}